import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

const Title = props => {
  return (
    <div styleName='title'>{props.label}</div>
  )
}

Title.propTypes = {
  label: PropTypes.string.isRequired,
}

export default CSSModules(Title, styles)
